import { Route, Navigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { resilientLazy } from "@/lib/resilientImport";

const Auth = resilientLazy(() => import("@/pages/Auth"), "Auth");
const AccountLinking = resilientLazy(() => import("@/pages/AccountLinking"), "AccountLinking");
const ForgotPassword = resilientLazy(() => import("@/pages/ForgotPassword"), "ForgotPassword");
const ResetPassword = resilientLazy(() => import("@/pages/ResetPassword"), "ResetPassword");
const OAuthCallback = resilientLazy(() => import("@/pages/OAuthCallback"), "OAuthCallback");

export const AuthRoutes = () => (
  <>
    <Route path={ROUTES.AUTH} element={<Auth />} />
    {/* Legacy redirect: /auth → /autenticacao */}
    <Route path="/auth" element={<Navigate to={ROUTES.AUTH} replace />} />
    <Route path="/oauth/callback" element={<OAuthCallback />} />
    <Route path={ROUTES.ACCOUNT_LINKING} element={<AccountLinking />} />
    <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
    <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
  </>
);
